import { useNavigate, useParams } from "react-router-dom";
import AppContainer from "src/components/app/common/AppContainer";
import { useTaxiReservationListQuery } from "src/hooks/coreApi/useTaxiReservationListQuery";
import { PATH_DASHBOARD } from "src/routes/paths";
import TaxiReservationForm from "src/components/app/taxiReservation/TaxiReservationForm";
import AppMenu from "src/components/app/common/AppMenu";
import { useTaxiReservationDeleteMutation } from "src/hooks/coreApi/useTaxiReservationDeleteMutation";
import AppAlertDialog, {
  useAppAlertDialog,
} from "src/components/app/common/AppAlertDialog";
import { useSnackbar } from "notistack";

export default function TaxiReservationEdit() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const taxiReservationQuery = useTaxiReservationListQuery({ id: Number(id) });
  const taxiReservation = taxiReservationQuery.data?.taxiReservations[0];
  const taxiReservationDeleteMutation = useTaxiReservationDeleteMutation();
  const alertDialog = useAppAlertDialog();
  const { enqueueSnackbar } = useSnackbar();

  const handleDeleteOk = () => {
    if (taxiReservation?.id) {
      taxiReservationDeleteMutation.mutate(
        {
          id: taxiReservation.id,
        },
        {
          onSuccess() {
            enqueueSnackbar("削除しました");
            navigate("/taxi/reservations");
          },
          onError(err) {
            // TODO エラー表示
            enqueueSnackbar("サーバーエラーが発生しました", {
              variant: "error",
            });
          },
        }
      );
    }
  };

  return (
    <>
      <AppContainer
        meta={{
          title: "予約詳細",
        }}
        breadcrumbs={{
          heading: "予約詳細",
          links: [
            { name: "ホーム", href: PATH_DASHBOARD.root },
            { name: "予約一覧", href: PATH_DASHBOARD.taxi.reservation },
            { name: "予約詳細" },
          ],
          action: (
            <AppMenu
              options={[
                {
                  label: "削除する",
                  onClick() {
                    alertDialog.onOpen();
                  },
                },
              ]}
            >
              その他の操作
            </AppMenu>
          ),
        }}
      >
        <TaxiReservationForm
          isEdit={true}
          currentTaxiReservation={taxiReservation}
        />
      </AppContainer>
      {taxiReservation && (
        <AppAlertDialog
          {...alertDialog}
          title="予約の削除"
          description={`予約 (ID: ${taxiReservation.id})を削除してもよろしいですか？`}
          onOk={handleDeleteOk}
        />
      )}
    </>
  );
}
